import {
  useEffect,
  useNavigate,
  useSelector,
  useContext,
} from "@/common/hooks";
import { PublicContext } from "@/routes/PublicRoute";

const Home = () => {
  const { Routes } = useContext(PublicContext);
  const navigate = useNavigate();
  const tokenFromStore = useSelector((state) => state?.authReducer?.token);

  useEffect(() => {
    if (tokenFromStore && tokenFromStore?.access_token) {
      navigate(Routes.dashboard.path);
    } else {
      navigate(Routes.login.path);
    }
  }, []);

  return <div className="home">Home</div>;
};

export default Home;
